import React, { useEffect } from "react";
import SizeSelector from "./SizeSelector.js";
import ColorChips from "./ColorChips.js";
import { formatDimensions } from "../utils/formatDimensions.js";
import { normalizeColors } from "../utils/colors.js";

export default function ItemModal({ item, size, setSize, onClose }) {
  useEffect(() => {
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => { document.body.style.overflow = prev; };
  }, []);

  const variant = item?.variants?.[size];
  const dimensions = variant?.dimensions ?? item?.dimensions;
  const colors = normalizeColors(variant?.colors ?? item?.colors);
  const dimsOut = formatDimensions(dimensions);

  return (
    <div className="modal-backdrop" role="dialog" aria-modal="true"
      onClick={(e) => e.target.classList.contains("modal-backdrop") && onClose()}>
      <div className="modal-content">
        <button className="modal-close" onClick={onClose} aria-label="Close">×</button>
        <div className="modal-layout">
          <div className="modal-image-wrap">
            <img src={item.imageUrl} alt={item.category || "Selected item"} />
          </div>
          <div className="modal-meta">
            {!!item?.variants && (
              <div className="modal-field">
                <h3>Size</h3>
                <SizeSelector sizes={Object.keys(item.variants)} value={size} onChange={setSize} />
              </div>
            )}
            {dimsOut && <div className="modal-field"><h3>Dimensions</h3><p>{dimsOut}</p></div>}
            {colors.length > 0 && <div className="modal-field"><h3>Colors available</h3><ColorChips colors={colors} /></div>}
            {!dimsOut && !colors.length && <p className="muted">No details available.</p>}
          </div>
        </div>
      </div>
    </div>
  );
}
